import { ErrorBoundary } from "components/Error/ErrorBoundary";
import { SandboxGitPanel } from "components/GitPanel/SandboxGitPanel";
import { SandboxInfo } from "components/Sandbox/SandboxInfo";
import { DependencyManager } from "components/Sidebar/DependencyManager";
import { useEditor } from "features/editor/Feature";
import { hasSandboxPermission } from "isomorphic/permission";
import { Box } from "prism-react";

import { executeVSCodeCommand } from "utils/vscode";

import { CustomSidebarView } from "./CustomSidebarView";
import githubLogo from "./icons/github.svg?url";

export const CustomSidebarItems: React.FC = () => {
  const project = useEditor();

  return (
    <>
      {project.type === "sandbox" && (
        <CustomSidebarView
          viewOptions={{
            id: "codesandbox.git.view",
            location: 0,
            name: "Export to GitHub",
            order: 100000,
            icon: new URL(githubLogo, import.meta.url).toString(),
          }}
        >
          <ErrorBoundary context="GIT_PANEL">
            <SandboxGitPanel />
          </ErrorBoundary>
        </CustomSidebarView>
      )}

      {project.type === "sandbox" && (
        <>
          <CustomSidebarView
            viewContainerId="workbench.view.explorer"
            viewOptions={{
              id: "codesandbox.sandbox.info",
              location: 0,
              name: project.customTemplate
                ? "Template info"
                : `${project.isCloud ? "Devbox" : "Sandbox"} Info`,
              order: 0,
              icon: "csb-icon://sandbox",
              collapsed: true,
              actions: hasSandboxPermission(
                project.authorization,
                "write_project",
              )
                ? [
                    {
                      id: "codesandbox.sandbox.info.edit",
                      title: "Edit",
                      tooltip: "Edit Info",
                      icon: "pencil",
                      run: async () => {
                        executeVSCodeCommand("codesandbox.openCsbTab", {
                          type: "SANDBOX_INFO",
                          isCloud: project.isCloud,
                        });
                      },
                    },
                  ]
                : [],
            }}
          >
            <Box css={{ padding: "$2 $2 $2 $5" }}>
              <SandboxInfo sandbox={project} />
            </Box>
          </CustomSidebarView>
          <DependencyManager />
        </>
      )}
    </>
  );
};
